import SchoolRow from '../schoolRow';
import './style.scss';

function SchoolItem({itemsDescription, itemSchool, municipalities,getSchoolsInfo}) {
    return (
        <div className='items-description-container'>
            <div className='description-container'>
                {itemsDescription.length > 0 &&
                    itemsDescription.map((itemD, i) => <p key={i}>{itemD.name}</p>)}
            </div>
            {itemSchool.length > 0 &&
                itemSchool.map((school, i) => {
                    if(school.groups && school.groups.length >0 ){
                        return school.groups.map((g, j)=>{
                            const updatedSchool = { ...school, groupInfo: g};
                            return <SchoolRow key={`${i}-${j}`} school={updatedSchool} municipalities={municipalities} getSchoolsInfo={getSchoolsInfo}/>
                        });

                    }else {
                        return <SchoolRow key={i} school={school} municipalities={municipalities} getSchoolsInfo={getSchoolsInfo}/>
                    }
                })}
        </div>
    );
}

export default SchoolItem;
